import { render, staticRenderFns } from "./AMCPastPapers.vue?vue&type=template&id=178738a6&scoped=true"
import script from "./AMCPastPapers.vue?vue&type=script&lang=js"
export * from "./AMCPastPapers.vue?vue&type=script&lang=js"
import style0 from "./AMCPastPapers.vue?vue&type=style&index=0&id=178738a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178738a6",
  null
  
)

export default component.exports